<template>
    <div class="page-reconciliation">
        <router-view></router-view>
        <RealtimeSystemMap/>
    </div>
</template>

<script>
import RealtimeSystemMap from "../components/MapV2/RealtimeSystem/RealtimeSystemMap.vue";
export default {
    name: 'PageReconciliationV2',
    components: {
        RealtimeSystemMap,
    },
    data: () => ({
        tabList: [
            {
                id: 'kit',
                name: 'Наборы',
                routeName: 'reconciliationKits',
                routePath: '/reconciliation/kits',
            },
            {
                id: 'offers',
                name: 'Предложения',
                routeName: 'reconciliationOffers',
                routePath: '/reconciliation/offers',
            },
            {
                id: 'approved',
                name: 'Предфакт',
                routeName: 'reconciliationApproved',
                routePath: '/reconciliation/approved',
            },
            {
                id: 'fact',
                name: 'Факт',
                routeName: 'reconciliationFact',
                routePath: '/reconciliation/fact',
            }
        ],
        actionsListMap: {
            reconciliationKits: [],
            reconciliationOffers: [],
            reconciliationApproved: ['download', 'import'],
            reconciliationFact: ['download']
        },
        isImport: false
    }),
    computed: {
        routerNameCurrent() {
            return this.$route.name;
        }
    },
    methods: {
        onImport() {
            this.isImport = true;
        },
        onCloseModalImport() {
            this.isImport = false;
        },
    }
}
</script>

<style lang="scss" scoped>
    .page-reconciliation {
        height: 100%;
        padding: 20px;
        display: flex;
        flex-direction: column;

        &__menu-tab-list {
            background: #fff;
            margin: 0 -40px 0 -40px;
            padding: 30px 40px 0 40px;
        }
    }
</style>
